import clsx from 'clsx';
import { ReactNode, PropsWithChildren, isValidElement, Children } from 'react';

import styles from './Breadcrumbs.module.css';
import { BreadcrumbsProps } from './types';

const Breadcrumbs = ({
  id = 'breadcrupbs',
  children,
  separator = '|',
  breadcrumbClassName,
  className,
  breadcrumbsContainerClassName,
}: PropsWithChildren<BreadcrumbsProps>) => {
  const breadcrumbsListClassNames: string = clsx(styles.breadcrumbs__list, className);
  const breadcrumbsSeparatorClassNames: string = clsx(styles.breadcrumbs__separator, breadcrumbClassName);

  const inSertSeparator = (items: Array<ReactNode>, breadcrumbsClassName: string): Array<ReactNode> => {
    return items.reduce<Array<ReactNode>>(
      (acc: Array<ReactNode>, current: ReactNode, index: number): Array<ReactNode> => {
        if (index < items.length - 1) {
          acc = acc.concat(
            current,
            <li className={breadcrumbsClassName} aria-hidden="true" key={`separator-${index}`}>
              {separator}
            </li>,
          );
        } else {
          acc.push(current);
        }
        return acc;
      },
      [],
    );
  };

  const allItems: Array<ReactNode> = Children.toArray(children)
    .filter((child: ReactNode): ReactNode => {
      return isValidElement(child);
    })
    .map((child: ReactNode, index: number): ReactNode => <li key={`breadcrumb-child-${index}`}>{child}</li>);

  return (
    <nav data-testid={'id'} id={id} className={clsx(styles.breadcrumbs, breadcrumbsContainerClassName)}>
      <ol className={breadcrumbsListClassNames}>{inSertSeparator(allItems, breadcrumbsSeparatorClassNames)}</ol>
    </nav>
  );
};

export default Breadcrumbs;
